import { Icon, IconFillColor } from '@design-system/components/atoms/icon/entities/icon.types';
import { TypographyColor, TypographyFontSize } from '@design-system/components/atoms/typography/entities/typography.types';

export enum RadioButtonAlign {
  Left = 'left',
  Right = 'right'
}

export enum RadioButtonSize {
  SM = 'sm',
  RG = 'rg',
  CustomSize = 'custom-size'
}

export enum RadioButtonFailedType {
  None = 'none',
  Error = 'error',
  Warning = 'warning',
}

export interface RadioButtonText {
  Label: string;
  Bold?: boolean;
  CustomSize?: TypographyFontSize;
  CustomColor?: TypographyColor;
  Icon?: Icon;
  CustomIconFill?: IconFillColor;
}
